module.exports = __webpack_public_path__ + "static/img/land33.7118edc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/land33.svg
// module id = 6kpt
// module chunks = 0